<template>
  <div class="columns is-multiline">
    <!-- Table search -->
    <div v-if="hasTitle || !hide_table_search" class="column is-12">
      <div class="field is-grouped">
        <p class="control title">
          <title-component class="center-vertically">
            <slot></slot>
          </title-component>
        </p>
      </div>
      <div class="form-field-set columns">
        <div class="column is-12">
          <div class="columns is-multiline">
            <div class="form-field column is-6">
              <div class="text-component">
                <div class="field">
                  <label for="certificate_number" class="label">
                    <span v-translate>Certificate number</span>
                  </label>
                  <div class="control">
                    <input
                      ref="search" class="input" type="text" id="certificate_number"
                      :placeholder="'Certificate number' | translate"
                      v-on:keyup.enter="onSearch" v-model="searchCertNumber">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-6">
              <div class="text-component">
                <div class="field">
                  <label for="certificate_holder" class="label">
                    <span v-translate>Certificate holder</span>
                  </label>
                  <div class="control">
                    <input
                      ref="search" class="input" type="text" id="certificate_holder"
                      :placeholder="'Certificate holder' | translate"
                      v-on:keyup.enter="onSearch" v-model="searchCertHolder">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-6">
              <div class="text-component">
                <div class="field">
                  <label for="company" class="label">
                    <span v-translate>Company</span>
                  </label>
                  <div class="control">
                    <input
                      ref="search" class="input" type="text" id="company"
                      :placeholder="'Company' | translate"
                      v-on:keyup.enter="onSearch" v-model="searchCompany">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-3">
              <div class="select-component">
                <div class="field">
                  <label for="service" class="label">
                    <span v-translate>Certification</span>
                  </label>
                  <div class="control">
                    <b-select v-model="searchService" :placeholder="'Choose certification' | translate" id="service">
                      <option value="" v-translate>
                        Choose service
                      </option>
                      <option
                        v-for="option in getFilterItems('service')"
                        :value="option.value"
                        :key="option.value">
                        {{ option.display }}
                      </option>
                    </b-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-3">
              <div class="select-component">
                <div class="field">
                  <label for="qualification" class="label">
                    <span v-translate>Qualification</span>
                  </label>
                  <div class="control">
                    <b-select
                      v-model="searchQualification"
                      :placeholder="'Choose qualification' | translate"
                      id="qualification"
                      :disabled="getFilterItemsDoubleLayer('qualification', searchService) == null">
                      <option value="" v-translate>
                        Choose qualification
                      </option>
                      <option
                        v-for="option in getFilterItemsDoubleLayer('qualification', searchService)"
                        :value="option.value"
                        :key="option.value">
                        {{ option.display }}
                      </option>
                    </b-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-6">
              <div class="select-component">
                <div class="field">
                  <label for="service" class="label">
                    <span v-translate>County</span>
                  </label>
                  <div class="control">
                    <b-select v-model="searchCounty" :placeholder="'Choose county' | translate" id="county">
                      <option value="" v-translate>
                        Choose county
                      </option>
                      <option
                        v-for="option in getFilterItems('county')"
                        :value="option.value"
                        :key="option.value">
                        {{ option.display }}
                      </option>
                    </b-select>
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-6">
              <div class="text-component">
                <div class="field">
                  <label for="city" class="label">
                    <span v-translate>City</span>
                  </label>
                  <div class="control">
                    <input
                      ref="search" class="input" type="text" id="city"
                      :placeholder="'City' | translate"
                      v-on:keyup.enter="onSearch" v-model="searchCity">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-6">
              <div class="text-component">
                <div class="field">
                  <label for="search" class="label">
                    <span v-translate>Search</span>
                  </label>
                  <div class="control">
                    <input
                      ref="search" class="input" type="text" id="search"
                      :placeholder="'Search' | translate"
                      v-on:keyup.enter="onSearch" v-model="search">
                  </div>
                </div>
              </div>
            </div>

            <div class="form-field column is-6">
              <submit-btn-component
                class="submit-btn is-uppercase is-primary is-large"
            style="background-color: rgb(0, 93, 161);margin-top: 26px;"
                @submit="onSearch($event)" ref="enterButton" v-translate>
                Search
              </submit-btn-component>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-holder">
      <b-table
        id="btable"
        class="table is-fullwidth"
        :data="content"
        :loading="loading"
        :paginated="false"
        backend-pagination
        :total="total"
        :per-page="perPage"
        backend-sorting
        :default-sort-direction="'desc'"
        :checked-rows.sync="checkedRows"
        @click="handleRowClick"
        @sort="onSortChange"
        :mobile-cards="true"
        :checkable="checkable">
        <!-- Column headers -->
        <template slot-scope="props" slot="header">
            <div>
              {{ props.column.label }}
            </div>
        </template>
        <!-- Column content -->
        <template slot-scope="props">
          <b-table-column
            v-for="(item_key, index) in item_keys"
            :key="index"
            :width="getColumnWidthForKey(item_key)"
            :numeric="isColumnAlignedRight(item_key, index)"
            :field="getSortForKey(item_key)"
            :meta="getFilterForKey(item_key)"
            :label="headings[index] | translate"
            :sortable="Boolean(getSortForKey(item_key))"
            :class="getColumnsToHide(item_key)">
            <table-cell-component
              :cell_item="getItemForKey(props.row, item_key)">
            </table-cell-component>
          </b-table-column>
        </template>

        <template slot="footer">
          <div v-if="isPaginated" class="custom-pagination level">
            <div class="level-left">
              <div class="level-item">
                <span v-translate="{total: total}">All results: %{ total }</span>
              </div>
            </div>
            <div class="level-right">
              <div class="level-item">
                <b-pagination
                  :total="total"
                  :current.sync="currentPage"
                  :per-page="perPage"
                  @change="onPageChange">
                </b-pagination>
              </div>
            </div>
          </div>
        </template>

        <!-- If the table is empty -->
        <template slot="empty">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p v-translate>The table is empty.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>

  </div>
</template>
<script>
  import TitleComponent from '@/components/layout/TitleComponent'
  import TableCellComponent from '@/components/layout/table/TableCellComponent'
  import { getDetailDisplayContext, getPageFromQuery, getSearchFromQuery, queryToFiltersPublic } from '@/utility/utility_functions'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent'

  export default {
    name: 'table-component-buefy-many-searches',
    data () {
      return {
        loading: false,
        total: this.total_items,
        currentPage: 1,
        currentOrder: null,
        perPage: 20,
        search: null,
        searchCertNumber: null,
        searchCertHolder: null,
        searchCompany: null,
        searchService: null,
        searchQualification: null,
        searchCity: null,
        searchCounty: null,
        selectedFilters: {},
        toggleFilters: {},
        timer: null,
        checkedRows: []
      }
    },
    props: {
      id: { // only for multiple table support
        default: ''
      },
      headings: {
        type: Array,
        required: true
      },
      filters: {
        type: Object,
        default: () => null
      },
      saved_filters: {
        type: Object,
        default: () => null
      },
      save_filters: {
        type: Boolean,
        default: false
      },
      save_page: {
        type: Boolean,
        default: false
      },
      save_search: {
        type: Boolean,
        default: false
      },
      item_keys: {
        type: Array,
        required: true
      },
      content: {
        type: Array,
        required: true
      },
      display_spec: {
        type: Array
      },
      total_items: {
        type: Number,
        default: 0
      },
      pagination_callback: {
        type: Function,
        required: false
      },
      hidden_columns: {
        type: Array,
        default: () => []
      },
      hide_table_search: {
        type: Boolean,
        default: false
      },
      default_search: {
        type: String,
        default: null
      },
      col_styles: {
        type: Object,
        default: () => ({})
      },
      checkable: {
        type: Boolean,
        default: false
      },
      auto_search: {
        type: Boolean,
        default: true
      }
    },
    components: {
      TitleComponent,
      TableCellComponent,
      SubmitBtnComponent
    },
    computed: {
      hasTitle () {
        return !!this.$slots.default
      },
      isPaginated () {
        return this.content.length && this.content.length < this.total
      }
    },
    methods: {
      getFilter (props) {
        let filter = this.filters[props.column.meta]
        if (!filter) return
        if (Array.isArray(filter)) {
          filter = { items: filter }
        }
        return filter
      },
      getFilterItems (key) {
        let filter = this.filters[key]
        if (!filter) return
        if (Array.isArray(filter)) {
          filter = { items: filter }
        }
        return filter.items
      },
      getFilterItemsDoubleLayer (key1, key2) {
        if (key2 === null) return
        let filter = this.filters[key1]
        if (!filter) return
        if (Array.isArray(filter)) {
          filter = filter[0]
        }
        filter = filter[key2]
        if (!filter) return
        if (Array.isArray(filter)) {
          filter = { items: filter }
        }
        return filter.items
      },
      getUid (props) {
        return props.column.meta
      },
      showFilterByIndex (index) {
        return this.showFilters[index]
      },
      setDefaultToggle (toggle, uid) {
        this.toggleFilters[uid] = toggle
      },
      setSelectedFilters (filters) {
        if (this.save_filters) {
          this.$router.push({ query: Object.assign({}, this.$route.query, filters) })
        }
        this.selectedFilters = Object.assign({}, filters)
        this.currentPage = 1
        this.loadPage()
      },
      handleRowClick (row) {
        if (!this.checkedRows.includes(row)) {
          this.checkedRows.push(row)
        } else {
          this.checkedRows = this.checkedRows.filter(i => i !== row)
        }
      },
      onSearch (btn) {
        clearTimeout(this.timer)
        this.resetPage()
        if (this.save_filters) {
          if (this.searchCertNumber) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { certificate_number: this.searchCertNumber }) })
          }
          if (!this.searchCertNumber) {
            this.$router.replace({ certificate_number: null })
          }
          if (this.searchService) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { service: this.searchService }) })
          }
          if (!this.searchService) {
            this.$router.replace({ service: null })
            this.searchQualification = null
            this.$router.replace({ qualification: null })
          }
          if (this.searchCertHolder) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { name: this.searchCertHolder }) })
          }
          if (!this.searchCertHolder) {
            this.$router.replace({ name: null })
          }
          if (this.searchCompany) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { company: this.searchCompany }) })
          }
          if (!this.searchCompany) {
            this.$router.replace({ company: null })
          }
          if (this.searchQualification) {
            if (this.searchService) {
              this.$router.push({ query: Object.assign({}, this.$route.query, { qualification: this.searchQualification }) })
            }
            if (!this.searchService) {
              this.$router.replace({ qualification: null })
            }
          }
          if (!this.searchQualification) {
            this.$router.replace({ qualification: null })
          }
          if (this.searchCity) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { city: this.searchCity }) })
          }
          if (!this.searchCity) {
            this.$router.replace({ city: null })
          }
          if (this.searchCounty) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { county: this.searchCounty }) })
          }
          if (!this.searchCounty) {
            this.$router.replace({ county: null })
          }
        }
        if (this.save_search) {
          this.$router.push({ query: Object.assign({}, this.$route.query, { search: this.search }) })
          this.currentPage = 1
          this.setSelectedFilters(this.$route.query)
          btn.enable()
          return
        }
        this.loadPage()
        btn.enable()
      },
      loadPage (page, order) {
        if (this.save_page) {
          if (!page) {
            page = getPageFromQuery(this.$route.query)
            this.currentPage = page
          }
        }
        if (this.save_search) {
          if (!this.search) {
            this.search = getSearchFromQuery(this.$route.query)
          }
        }
        if (this.save_filters) {
          let searches = queryToFiltersPublic(this.$route.query)
          if (!this.searchCertNumber) {
            this.searchCertNumber = searches['certificate_number'] || null
          }
          if (!this.searchService) {
            this.searchService = searches['service'] || null
            if (!this.searchService) {
              this.searchQualification = null
            }
          }
          if (!this.searchCertHolder) {
            this.searchCertHolder = searches['name'] || null
          }
          if (!this.searchCompany) {
            this.searchCompany = searches['company'] || null
          }
          if (!this.searchQualification) {
            this.searchQualification = searches['qualification'] || null
            if (!this.searchService) {
              this.searchQualification = null
            }
          }
          if (!this.searchCity) {
            this.searchCity = searches['city'] || null
          }
          if (!this.searchCounty) {
            this.searchCounty = searches['county'] || null
          }
        }
        let queryParams = {
          page: page || this.currentPage,
          ordering: order || this.currentOrder,
          search: this.search || this.default_search
        }
        if (this.searchCertNumber !== null) {
          queryParams['certificate_number'] = this.searchCertNumber
          if (this.save_filters) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { certificate_number: this.searchCertNumber }) })
          }
        }
        if (this.searchService !== null) {
          queryParams['service'] = this.searchService
          if (this.save_filters) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { service: this.searchService }) })
          }
        }
        if (this.searchCertHolder !== null) {
          queryParams['name'] = this.searchCertHolder
          if (this.save_filters) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { name: this.searchCertHolder }) })
          }
        }
        if (this.searchCompany !== null) {
          queryParams['company'] = this.searchCompany
          if (this.save_filters) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { company: this.searchCompany }) })
          }
        }
        if (this.searchQualification !== null && this.searchService !== null) {
          queryParams['qualification'] = this.searchQualification
          if (this.save_filters) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { qualification: this.searchQualification }) })
          }
        }
        if (this.searchCity !== null) {
          queryParams['city'] = this.searchCity
          if (this.save_filters) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { city: this.searchCity }) })
          }
        }
        if (this.searchCounty !== null) {
          queryParams['county'] = this.searchCounty
          if (this.save_filters) {
            this.$router.push({ query: Object.assign({}, this.$route.query, { county: this.searchCounty }) })
          }
        }
        Object.assign(queryParams, this.selectedFilters)
        if (this.save_page) {
          this.$router.push({ query: Object.assign({}, this.$route.query, { page: page }) })
        }
        this.loading = true
        this.pagination_callback && this.pagination_callback(queryParams).then((items) => {
          this.loading = false
          this.total = items ? items.count : 0
        })
      },
      resetPage () {
        this.currentPage = 1
        if (this.save_page) {
          this.$router.push({ query: Object.assign({}, this.$route.query, { page: this.currentPage }) })
        }
      },
      onPageChange (page) {
        this.currentPage = page
        this.loadPage(page)
      },
      onSortChange (columnKeys, isAsc) {
        if (isAsc !== 'asc') {
          columnKeys = '-' + columnKeys.replace(',', `,-`)
        }
        this.currentOrder = columnKeys
        this.loadPage(this.currentPage, columnKeys)
      },
      displayContext: function (item) {
        return getDetailDisplayContext(item, this.display_spec)
      },
      getItemForKey (item, key) {
        let displayContext = this.displayContext(item)
        return displayContext.find(i => i.item_key === key)
      },
      getSortForKey (key) {
        return this.display_spec.find(i => i.item_key === key).sort_key
      },
      getFilterForKey (key) {
        return this.display_spec.find(i => i.item_key === key).filter
      },
      getColumnWidthForKey (key) {
        let columnContext = this.display_spec.find(i => i.item_key === key)
        return columnContext.width
      },
      getColumnsToHide (columnKey) {
        return {
          'is-hidden-touch': this.hidden_columns.includes(columnKey)
        }
      },
      getLabelForColumn (column) {
        let colIndex = Array.prototype.indexOf.call(column.parentNode.getElementsByTagName('td'), column)
        return document.getElementById('btable').getElementsByTagName('th')[colIndex]
      },
      hideColumnLabels (colsToHide) {
        for (let col of colsToHide) {
          this.getLabelForColumn(col) && this.getLabelForColumn(col).classList.add('is-hidden-touch')
        }
      },
      getColumnStylesForKey (itemKey) {
        return this.col_styles[itemKey] || []
      },
      isColumnAlignedRight (itemKey, index) {
        let colStyles = this.getColumnStylesForKey(itemKey)
        return index + 1 === this.item_keys.length && !colStyles.includes('alignLeft')
      }
    },
    created () {
      this.perPage = this.content.length || 20
      this.setSelectedFilters(this.saved_filters)
    },
    mounted () {
      this.$refs.search && this.$refs.search.focus()
    },
    updated () {
      this.hideColumnLabels(document.getElementsByClassName('is-hidden-touch'))
    },
    watch: {
      checkedRows () {
        this.$emit(`checked-row-handler${this.id}`, this.checkedRows)
      }
    }
  }
</script>
<style lang="sass" scoped>
  .center-vertically
    line-height: 2.2em
  .is-grouped
    @media(max-width: 768px)
      flex-direction: column
  .title
    flex: 1
  .search
    flex: 1
    margin-bottom: 0.5385em
  .custom-pagination
    margin-top: 3rem
  .form-field
    margin-bottom: 15px
</style>
